import { RightOutlined, StarFilled } from "@ant-design/icons";
import { Typography } from "antd";
import { Link } from "react-router-dom";
import { ReaderTopic } from "../../types/helpCentre.types";
import { guideCount, helpTopicPath } from "../../utils/helpCentre/content";
import { HelpTopicIcon } from "./HelpIcon";

/**
 * A topic as a card that is one link, so it can be reached and opened by
 * keyboard and opened in a new tab. Its icons are decorative: Ant's icons
 * otherwise add their names to the link's.
 */
function TopicCard({ topic }: Readonly<{ topic: ReaderTopic }>) {
	return (
		<Link className="help-topic-card" to={helpTopicPath(topic.key)}>
			<span className="help-topic-card__icon">
				<HelpTopicIcon name={topic.icons} />
			</span>
			<span className="help-topic-card__text">
				<Typography.Text
					className="help-topic-card__title"
					ellipsis={{ tooltip: topic.topicTitle }}
				>
					{topic.topicTitle}
				</Typography.Text>
				<span className="help-topic-card__count">{guideCount(topic)}</span>
			</span>
			{topic.isImportant && (
				<>
					<StarFilled aria-hidden="true" className="help-topic-card__star" />
					<span className="sr-only">Featured</span>
				</>
			)}
			<RightOutlined aria-hidden="true" className="help-topic-card__chevron" />
		</Link>
	);
}

export default TopicCard;
